import isPropValid from '@emotion/is-prop-valid';

export function propsToDom(object) {
  return Object.keys(object).reduce((acc, key) => {
    if (isPropValid(key)) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
}
